import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { Component } from 'react'; // eslint-disable-line
import ManagedInput from './ManagedInput';
import ManagePasswordInput from "./ManagePasswordInput";
import constants from '../../constants';

class ValidatedInput extends Component {
    constructor(props) {
        super(props);

        this.state = {
            value: !props.value ? '' : props.value,
            isFocused: false,
        };

        this.onChangeFn = this.onChangeFn.bind(this);
        this.onBlurFn = this.onBlurFn.bind(this);
        this.onFocusFn = this.onFocusFn.bind(this);
    }

    componentDidUpdate(prevProps, prevState) {
        if (this.props.value !== prevProps.value && this.props.value !== prevState.value) {
            // eslint-disable-next-line react/no-did-update-set-state
            this.setState({
                value: !this.props.value ? '' : this.props.value,
            });
        }
    }

    onChangeFn(e) {
        this.setState({
            value: e.target.value,
        });

        if (this.props.onChange) {
            this.props.onChange(e);
        }
    }

    onBlurFn(e) {
        this.setState({
            isFocused: false,
        });

        if (this.props.onBlur) {
            this.props.onBlur(e);
        }
    }

    onFocusFn() {
        this.setState({
            isFocused: true,
        });
    }

    render() {
        let {
            containerClass,
            labelText,
            charLimit,
            placeholder,
            shortHelpText,
            name,
            hasError,
            errorMessage,
            hasSuccess,
            successMessage,
            multiline,
            type,
            onReturnDown,
            disabled,
            autoComplete,
            withIcon
        } = this.props;

        type = !type ? 'text' : type;

        const charCount = this.state.value.length;
        const id = this.props.id ? this.props.id : containerClass;
        containerClass = this.state.isFocused ? (`${containerClass} is-focused`) : containerClass;
        containerClass = charCount > 0 ? (`${containerClass} has-value`) : containerClass;
        if (hasError) {
            containerClass += ' has-error';
        } else if (hasSuccess) {
            containerClass += ' has-success';
        }
        let successErrorClass = '';
        let helpText = (<p className="help-text">{shortHelpText}</p>);
        if (hasError) {
            successErrorClass = 'error';
            if (errorMessage) {
                helpText = (
                    <div className="alert-text error">
                        <div className="alert-icon-holder">
                            <FontAwesomeIcon icon={['far', 'exclamation-circle']} color={constants.StyleColors.error2} size="sm" />
                        </div>
                        <p className="error">{errorMessage}</p>
                    </div>
                );
            }
        } else if (hasSuccess) {
            successErrorClass = 'success';
            if (successMessage) {
                helpText = (
                    <div className="alert-text success">
                        <div className="alert-icon-holder">
                            <FontAwesomeIcon icon={['far', 'check']} color={constants.StyleColors.successDark} size="sm" />
                        </div>
                        <p className="success">{errorMessage}</p>
                    </div>
                );
            }
        }

        let inputElement = (
            <ManagedInput
                successErrorClass={successErrorClass}
                type={type}
                onFocus={this.onFocusFn}
                onReturnDown={onReturnDown}
                name={name}
                value={this.props.value}
                onBlur={this.onBlurFn}
                onChange={this.onChangeFn}
                maxLength={charLimit}
                placeholder={placeholder}
                multiline={multiline}
                autoFocus={false}
                id={id}
                disabled={disabled}
                autoComplete={autoComplete}
            />
        );

        if(type === 'password' && withIcon) {
            inputElement = (
                <ManagePasswordInput
                    successErrorClass={successErrorClass}
                    type={type}
                    onFocus={this.onFocusFn}
                    onReturnDown={onReturnDown}
                    name={name}
                    value={this.props.value}
                    onBlur={this.onBlurFn}
                    onChange={this.onChangeFn}
                    maxLength={charLimit}
                    placeholder={placeholder}
                    multiline={multiline}
                    autoFocus={false}
                    id={id}
                    disabled={disabled}
                    autoComplete={autoComplete}
                />
            );
    
        }

        return (
            <div className={`form-control ${containerClass}`} data-qa={`wrapper-for-${id}`}>
                <label className={successErrorClass} data-qa={`label-for-${id}`}>{labelText}</label>
                <div className={charLimit > 0 ? 'input-wrapper show-remaining' : 'input-wrapper'}>
                    {inputElement}
                    {charLimit
                        && (
                            <div className="remaining" data-qa={`character-counter-for-${id}`}>
                                {charCount} / {charLimit} {/* eslint-disable-line */}
                            </div>
                        )}
                </div>
                {helpText}
            </div>
        );
    }
}

export default ValidatedInput;
